export function taskBadgeLabel(count: number) {
  return count > 99 ? '99+' : String(count)
}
